module.exports = __webpack_public_path__ + "assets/img/67bf74975d522fb7504ad0723ba24951.png";